import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";
import { ErrorMonitoringService } from "@/shared/services";

import { dashboardQueryKeys } from "./dashboardQueryKeys";

export function useDeleteDashboard() {
  const { dashboardService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dashboardId: string) => {
      if (currentOrganization === null) {
        return Promise.reject(new Error("CurrentOrganization is not set"));
      }
      return dashboardService.deleteDashboard(
        dashboardId,
        currentOrganization.org_id,
      );
    },
    onSuccess: (_void, dashboardId) => {
      // The single-dashboard cache is keyed by org, so a removal is only
      // meaningful with an org to scope it; without one there is nothing it
      // could match. (In practice the mutation only succeeds when
      // currentOrganization is set.)
      if (currentOrganization !== null) {
        queryClient.removeQueries({
          queryKey: dashboardQueryKeys.id(
            dashboardId,
            currentOrganization.org_id,
          ),
        });
      }
      void queryClient.invalidateQueries({
        queryKey: dashboardQueryKeys.lists(currentOrganization?.org_id),
      });
    },
    onError: (error) => {
      ErrorMonitoringService.captureError(error);
    },
  });
}
